import {
  BannerButtons,
  BannerDescription,
  BannerStyled,
  BannerText,
} from './Banner.styled';
import { CookiePolicyLink } from './CookieConsentBanner.styled';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { CommonButton } from '../../../components/common/Forms/Button';
import { Trans } from 'react-i18next';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { COOKIE_POLICY_ROUTE } from '../../../routes/AppRoutes';
import { useHistory } from 'react-router-dom';
import { useCookiesConsent } from '../../../hooks/storage/useCookiesConsent';

export const CookieConsentBanner = () => {
  const { t } = useCommonTranslation();
  const { location } = useHistory();

  const { nonEssentialCookiesApproved, updateConsent } = useCookiesConsent();
  const open =
    nonEssentialCookiesApproved === undefined &&
    location.pathname !== COOKIE_POLICY_ROUTE;

  if (!open) {
    return null;
  }

  return (
    <BannerStyled>
      <BannerDescription>
        <h2>{t('cookies-consent-header')}</h2>
        <BannerText>
          <Trans
            i18nKey="cookies-consent-text"
            components={{
              cookiePolicyUrl: (
                <CookiePolicyLink
                  to={COOKIE_POLICY_ROUTE}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('cookies-policy')}
                </CookiePolicyLink>
              ),
              icon: <FaExternalLinkAlt size={12} />,
            }}
          />
        </BannerText>
      </BannerDescription>
      <BannerButtons>
        <CommonButton
          variant={'secondary'}
          size={'large'}
          onClick={() => {
            updateConsent(false);
          }}
        >
          {t('cookies-consent-reject')}
        </CommonButton>
        <CommonButton
          onClick={() => {
            updateConsent(true);
          }}
          variant={'primary'}
          size={'large'}
          data-testid={'cookies-consent-agree'}
        >
          {t('cookies-consent-agree')}
        </CommonButton>
      </BannerButtons>
    </BannerStyled>
  );
};
